var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_983_34689)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C2.34315 2 1 3.34315 1 5V9C1 10.6569 2.34315 12 4 12H10C11.6569 12 13 10.6569 13 9V5C13 3.34315 11.6569 2 10 2H4ZM3.94596 4.00144C3.96385 4.00048 3.98187 4 4 4H10C10.0182 4 10.0362 4.00048 10.0541 4.00144L7.00003 5.83388L3.94596 4.00144ZM3 5.76624V9C3 9.55228 3.44772 10 4 10H10C10.5523 10 11 9.55228 11 9V5.76628L7.51453 7.85756C7.19784 8.04757 6.80222 8.04757 6.48554 7.85756L3 5.76624Z",
    fill: "#19A66B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_983_34689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvited);
export default __webpack_public_path__ + "static/media/Invited.05b00ecb875f3d4b62b2012f844fec2c.svg";
export { ForwardRef as ReactComponent };